/**
 * Ad for in the footer
 */

// Import statements
import * as React from "react"

/**
 * Define the AdFooter constant
 * @returns {JSX.Element}
 * @constructor
 */
const AdFooter = () => {

    // return information
    return (
        <div id="header-lift-banner-wrapper"></div>
    )
}

/**
 * Export the AdFooter variable
 */
export default AdFooter
